// Shared constants used by quote-tool lite libraries
// Extracted from apps/quote-tool-lite to avoid libs -> apps dependency
export const HIDE_DIALOG_DELAY = 300;
